export default __webpack_public_path__ + "static/media/logo_white.f8dbe778.svg";